<div class="row align">
    <img src="assets/images/404.jpg" alt="404" title="404">
</div>

